import { useState, useEffect } from "react";
import {
  faCaretLeft,
  faCaretRight,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Radium, { StyleRoot } from "radium";
import { fadeInRightBig } from "react-animations";
import Img from "react-image";
import Slider from "react-slick";
import Carousel, { Modal, ModalGateway } from "react-images";
import Media, { useMediaQuery } from "react-responsive";

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import torreTexao1 from "./../../assets/images2/realEstate/torreTexao/FAC1.jpg";
import torreTexao2 from "./../../assets/images2/realEstate/torreTexao/FAC2.jpg";
import torreTexao3 from "./../../assets/images2/realEstate/torreTexao/FAC3.jpg";

import "./sass/index.sass";

const imagesTexao = [torreTexao1, torreTexao2, torreTexao3];
const widths = [910, 494, 480];

const styles = {
  fadeInRightBig: {
    animation: "x 1s",
    animationName: Radium.keyframes(fadeInRightBig, "fadeInRightBig"),
  },
};

const Gallery = () => {
  const [itemsGallery, setItemsGallery] = useState<
    { img: string; width: string }[]
  >([]);
  const [itemsModal, setItemsModal] = useState<
    { source: string; id: number }[]
  >([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const isTablet = useMediaQuery({ query: "(max-width: 1224px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 600px)" });

  useEffect(() => {
    const ratio = isMobile ? 0.27 : isTablet ? 0.55 : 0.69;
    const gallery = imagesTexao.map((v, index) => {
      return {
        img: v,
        width: `${Math.floor(widths[index] * ratio)}px`,
      };
    });

    const modal = imagesTexao.map((v, index) => {
      return {
        source: v,
        id: index,
      };
    });

    setItemsGallery(gallery);
    setItemsModal(modal);
  }, []);

  const settings = {
    className: "center",
    centerMode: itemsGallery.length > 1 ? true : false,
    infinite: itemsGallery.length > 1 ? true : false,
    centerPadding: itemsGallery.length > 1 ? "75px" : "",
    slidesToShow: 1,
    speed: 1500,
    variableWidth: true,
    prevArrow: (
      <button>
        <FontAwesomeIcon icon={faCaretLeft} />
      </button>
    ),
    nextArrow: (
      <button>
        <FontAwesomeIcon icon={faCaretRight} />
      </button>
    ),
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          centerPadding: itemsGallery.length > 1 ? "0px" : "",
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: itemsGallery.length > 1 ? "0px" : "",
        },
      },
    ],
  };

  return (
    <StyleRoot>
      <div className="cont-about">
        <div className="cont-gallery" style={styles.fadeInRightBig}>
          <Slider {...settings}>
            {itemsGallery.map(({ img, width }, index) => (
              <div
                className="item"
                key={index}
                style={{ width: width }}
                onClick={() => {
                  setCurrentIndex(index);
                  setModalIsOpen(true);
                }}
              >
                <div className="cont-img-slide">
                  <Img
                    src={img}
                    alt=""
                    loader={
                      <div className="loader-image">
                        <FontAwesomeIcon icon={faSpinner} pulse />
                      </div>
                    }
                  />
                </div>
              </div>
            ))}
          </Slider>
          <ModalGateway>
            {modalIsOpen ? (
              <Modal onClose={() => setModalIsOpen(false)}>
                <Carousel
                  views={itemsModal}
                  currentIndex={currentIndex}
                  styles={{
                    view: (base: any) => ({
                      ...base,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100vh",
                    }),
                  }}
                />
              </Modal>
            ) : null}
          </ModalGateway>
        </div>
      </div>
    </StyleRoot>
  );
};

export default Gallery;
